package com.klantenstop.web.pages.settings

import com.klantenstop.web.utils.MVI
import com.varabyte.kobweb.silk.theme.colors.ColorMode

interface SettingsContract : MVI<SettingsContract.State, SettingsContract.Intent, SettingsContract.Effect> {

    data class State(
        val currentColorMode: ColorMode,
        val hoveringColorMode: ColorMode = currentColorMode
    )

    sealed class Intent {
        data class UpdateHoveringColorMode(val colorMode: ColorMode) : Intent()
        data class SelectColorMode(val colorMode: ColorMode) : Intent()
        data object ManageConsent : Intent()
    }

    sealed class Effect {
        data class SelectColorMode(val colorMode: ColorMode) : Effect()
        data object OpenConsentModal : Effect()
    }
}
